<template>
    <!-- Alert with link-action  -->
    <router-link
        v-if="isRouterLink"
        class="popover-menu-item"
        v-bind="alert.params"
        :key="alert.id">
        <h2 v-if="alert.title">{{alert.title | unKebabCase}}</h2>
        <p v-if="alert.message">{{alert.message | unKebabCase}}</p>
    </router-link>
    <!-- Default Alert -->
    <div
        v-else
        class="popover-menu-item display-flex"
        :key="alert.id">
        <h4 v-if="alert.title">{{alert.title | unKebabCase}}</h4>
        <p v-if="alert.message">{{alert.message | unKebabCase}}</p>
    </div>
</template>

<script>
    import AlertModel from '@/common/models/alerts/alert-model';

    export default {
        props: {
            alert: AlertModel,
        },
        computed: {
            isRouterLink() {
                return this.alert.type === AlertModel.Types.link;
            },
        },
    };
</script>
